"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var Card_meta_1 = require("./Card.meta");
var shared_1 = require("../../../shared");
var Body_1 = __importDefault(require("./styledComponents/Body"));
var Footer_1 = __importDefault(require("./styledComponents/Footer"));
var Header_1 = __importDefault(require("./styledComponents/Header"));
var Subtitle_1 = __importDefault(require("./styledComponents/Subtitle"));
var Title_1 = __importDefault(require("./styledComponents/Title"));
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var Tooltip_1 = __importDefault(require("../Tooltip"));
var Translate_1 = __importDefault(require("../Translate"));
var Disclaimers_1 = __importDefault(require("../../overview/Disclaimers"));
var Heading_1 = __importDefault(require("../Heading"));
var Superscript_1 = __importDefault(require("../Table/styledComponents/Superscript"));
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = Card_meta_1.CARD_CATEGORY_KEY;
        _this.componentKey = Card_meta_1.CARD_COMPONENT_KEY;
        _this.getDisclaimersProps = function () {
            var _a;
            var _b = _this.props, footerDisclaimers = _b.footerDisclaimers, disclaimerKey = _b.disclaimerKey;
            var globalDisclaimersStore = ksys_app_template_1.utils.globalDisclaimers.getGlobalDisclaimerStore();
            var response = JSON.parse(ksys_app_template_1.utils.json.stringifySafe(footerDisclaimers || {}));
            if (globalDisclaimersStore) {
                var appKey = _this.props.configuration && _this.props.configuration.appKey || '123';
                var superscriptKey = Card_1.generateSuperscriptKey(appKey, disclaimerKey);
                if (superscriptKey) {
                    var globalDisclaimersForApp = globalDisclaimersStore.get(ksys_app_template_1.models.disclaimers.GlobalDisclaimerLevel.app, superscriptKey);
                    if (globalDisclaimersForApp && globalDisclaimersForApp.length > 0) {
                        if (!response.disclaimers) {
                            response.disclaimers = [];
                        }
                        (_a = response.disclaimers).push.apply(_a, globalDisclaimersForApp.map(function (globalDisclaimerForApp) {
                            var disclaimerProps = {
                                text: globalDisclaimerForApp.text,
                                superscript: typeof globalDisclaimerForApp.superscript === 'number'
                                    ? globalDisclaimerForApp.superscript.toString()
                                    : globalDisclaimerForApp.superscript,
                            };
                            return disclaimerProps;
                        }));
                    }
                }
            }
            return response;
        };
        return _this;
    }
    Card_1 = Card;
    Card.prototype.getTooltipTarget = function (target) {
        var tooltips = this.props.tooltips;
        var response;
        if (Array.isArray(tooltips) && tooltips.length > 0) {
            response = tooltips.find(function (tooltip) { return tooltip.target === target; });
        }
        return response;
    };
    Card.prototype.getTooltip = function (tooltip) {
        var target = tooltip.target, tooltipProps = __rest(tooltip, ["target"]);
        return tooltipProps && react_1.default.createElement(Tooltip_1.default, __assign({}, tooltipProps));
    };
    Card.generateSuperscriptKey = function (appKey, disclaimerKey) {
        return disclaimerKey ? appKey + "-" + disclaimerKey : appKey;
    };
    Card.addSuperscriptDisclaimers = function (appKey, superscripts, targetedDisclaimers, conditionalContext, responseContext, globalDisclaimerStore, queryStore) {
        var disclaimers = targetedDisclaimers.disclaimers, conditional = targetedDisclaimers.conditional;
        if (conditional) {
            var conditionalHelper = new ksys_app_template_1.helpers.ConditionalHelper(conditional);
            if (conditionalHelper.matchesWithOptions({ instance: conditionalContext, executionOptions: { responseContext: conditionalContext } })) {
                superscripts.push.apply(superscripts, globalDisclaimerStore.add.apply(globalDisclaimerStore, __spreadArrays([appKey, responseContext, queryStore], disclaimers)));
            }
        }
        else {
            superscripts.push.apply(superscripts, globalDisclaimerStore.add.apply(globalDisclaimerStore, __spreadArrays([appKey, responseContext, queryStore], disclaimers)));
        }
    };
    Object.defineProperty(Card.prototype, "header", {
        get: function () {
            var _a = this.props, titleId = _a.titleId, title = _a.title, titleLevel = _a.titleLevel, subtitle = _a.subtitle, subtitleLevel = _a.subtitleLevel, disclaimers = _a.disclaimers;
            var titleTooltip = this.getTooltipTarget('title');
            var subTitleTooltip = this.getTooltipTarget('subTitle');
            var titleSuperscripts = disclaimers && disclaimers._titleSuperscripts;
            var subTitleSuperscripts = disclaimers && disclaimers._subTitleSuperscripts;
            return (react_1.default.createElement(Header_1.default, null,
                title && !titleLevel && (react_1.default.createElement(Title_1.default, { id: titleId || "heading-h2-" + ksys_app_template_1.utils.guid.generateGuid() },
                    react_1.default.createElement(Translate_1.default, null, title),
                    titleTooltip && this.getTooltip(titleTooltip),
                    titleSuperscripts && react_1.default.createElement(Superscript_1.default, null, titleSuperscripts.join(',')))),
                title && titleLevel && (react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement(Heading_1.default, { id: titleId, level: titleLevel, title: title }),
                    titleTooltip && this.getTooltip(titleTooltip),
                    titleSuperscripts && react_1.default.createElement(Superscript_1.default, null, titleSuperscripts.join(',')))),
                subtitle && !subtitleLevel && (react_1.default.createElement(Subtitle_1.default, null,
                    react_1.default.createElement(Translate_1.default, null, subtitle),
                    subTitleTooltip && this.getTooltip(subTitleTooltip),
                    subTitleSuperscripts && react_1.default.createElement(Superscript_1.default, null, subTitleSuperscripts.join(',')))),
                subtitle && subtitleLevel && (react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement(Heading_1.default, { level: subtitleLevel, title: subtitle }),
                    subTitleTooltip && this.getTooltip(subTitleTooltip),
                    subTitleSuperscripts && react_1.default.createElement(Superscript_1.default, null, subTitleSuperscripts.join(','))))));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Card.prototype, "footer", {
        get: function () {
            var _a = this.props, footerContent = _a.footerContent, hideDisclaimers = _a.hideDisclaimers;
            var disclaimersProps = this.getDisclaimersProps();
            if (footerContent || disclaimersProps) {
                return (react_1.default.createElement(Footer_1.default, null,
                    footerContent && react_1.default.createElement(Translate_1.default, null, footerContent),
                    !hideDisclaimers && disclaimersProps && (react_1.default.createElement(Disclaimers_1.default, __assign({}, disclaimersProps)))));
            }
        },
        enumerable: true,
        configurable: true
    });
    Card.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        return (react_1.default.createElement(Wrapper_1.default, { className: className },
            this.header,
            react_1.default.createElement(Body_1.default, null,
                react_1.default.createElement(Translate_1.default, null, children)),
            this.footer));
    };
    var Card_1;
    Card.loadSuperscripts = function (appKey, queryStore, cardProps, disclaimerKey) {
        var disclaimers = cardProps.disclaimers;
        var superscriptKey = Card_1.generateSuperscriptKey(appKey, disclaimerKey);
        if (disclaimers) {
            var rawTitleDisclaimers = disclaimers.title, rawSubTitleDisclaimers = disclaimers.subTitle;
            ksys_app_template_1.utils.globalDisclaimers.initializeGlobalDisclaimers();
            var globalDisclaimerStore = ksys_app_template_1.utils.globalDisclaimers.getGlobalDisclaimerStore();
            var titleDisclaimers = [];
            var subTitleDisclaimers = [];
            if (rawTitleDisclaimers) {
                for (var _i = 0, rawTitleDisclaimers_1 = rawTitleDisclaimers; _i < rawTitleDisclaimers_1.length; _i++) {
                    var targetedTitleDisclaimer = rawTitleDisclaimers_1[_i];
                    Card_1.addSuperscriptDisclaimers(superscriptKey, titleDisclaimers, targetedTitleDisclaimer, cardProps, cardProps, globalDisclaimerStore, queryStore);
                }
                if (titleDisclaimers.length > 0) {
                    disclaimers._titleSuperscripts = titleDisclaimers.map(function (titleDisclaimer) { return titleDisclaimer.superscript; }).sort();
                }
            }
            if (rawSubTitleDisclaimers) {
                for (var _a = 0, rawSubTitleDisclaimers_1 = rawSubTitleDisclaimers; _a < rawSubTitleDisclaimers_1.length; _a++) {
                    var targetedSubTitleDisclaimer = rawSubTitleDisclaimers_1[_a];
                    Card_1.addSuperscriptDisclaimers(superscriptKey, subTitleDisclaimers, targetedSubTitleDisclaimer, cardProps, cardProps, globalDisclaimerStore, queryStore);
                }
                if (subTitleDisclaimers.length > 0) {
                    disclaimers._subTitleSuperscripts = subTitleDisclaimers.map(function (subTitleDisclaimer) { return subTitleDisclaimer.superscript; }).sort();
                }
            }
        }
    };
    __decorate([
        mobx_1.computed
    ], Card.prototype, "header", null);
    __decorate([
        mobx_1.computed
    ], Card.prototype, "footer", null);
    Card = Card_1 = __decorate([
        mobx_react_1.observer
    ], Card);
    return Card;
}(shared_1.ComponentBase));
exports.Card = Card;
exports.default = shared_1.InjectedStyledComponent(Card, Card_meta_1.CARD_CATEGORY_KEY, Card_meta_1.CARD_COMPONENT_KEY);
